import React, { FC, ReactNode } from 'react';
import Row from 'components/UI/Row';
import { Desktop, Mobile } from '../MediaQuery';

interface SearchDepartmentProps {
  children: ReactNode;
  showDepartments: boolean;
}

const SearchDepartment: FC<SearchDepartmentProps> = ({ children, showDepartments }) => (
  <>
    <Mobile>
      <Row justifyContent="space-around" style={{ marginTop: '10px' }}>
        {children}
      </Row>
    </Mobile>
    <Desktop>
      <div className="show-departments-wrapper">{children}</div>
      <style jsx>
        {`
          .show-departments-wrapper {
            z-index: 100;
            background: #ffffff;
            display: flex;
            align-items: center;
            padding-left: 10px;
            height: 40px;
            position: absolute;
            width: 100%;
            overflow: hidden;
            ${showDepartments ? 'transition: max-height 0.1s linear' : ''}
            height: ${showDepartments ? '100%' : '0'};
          }
        `}
      </style>
    </Desktop>
  </>
);

export default SearchDepartment;
